import { createFileRoute } from '@tanstack/react-router'
import { VendorPanelActiveCallsPage } from '@/features/vendor-panel/pages/active-calls-page'

export const Route = createFileRoute('/_authenticated/vendor-panel/active-calls')({
  component: VendorPanelActiveCallsPage,
})
